import React, { useState } from "react";
import styles from "./Services.module.scss";
import { buildApiUrl } from "src/helpers/imageHelpers";
import { Container } from "react-bootstrap";
import Image from "next/future/image";
import { FormattedMessage } from "react-intl";
import BlueHoleIcon from "../../../public/logo.png";
import ArrowLeft from "../../svg/ic-left.svg";
import ArrowRight from "../../svg/ic-right.svg";

import { SwiperSlide, Swiper } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css/navigation";
import "swiper/css";

import { useRouter } from "next/router";
import Link from "next/link";
const ServiceSlide = ({ service, dir, locale }) => {
  const [isHovered, setIsHovered] = useState(false);

  const blockStyle = {
    textAlign: "center",
    boxShadow: "0 0 10px #0000001a",
    borderRadius: "10px",
    height: "calc(100% - 25px)",
    transition: "0.3s",
    transform: isHovered ? "translateY(-10px)" : "translateY(0)",
    textDecoration: "none",
  };

  const blockImgStyle = {
    borderRadius: "10px 10px 0 0",
    position: "relative",
    overflow: "hidden",
    height: "200px",
    margin: "0 auto",
    backgroundColor: "#f7f7f7",
    border: "1px solid #dfdfdf",
  };

  const imgStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "0.3s",
    transform: isHovered ? "scale(1.1)" : "scale(1)",
  };

  const linkStyle = {
    position: "absolute",
    inset: "0",
    zIndex: "1",
  };

  const contentStyle = {
    padding: "20px",
  };

  const titleStyle = {
    fontSize: "18px",
    display: "inline-block",
    fontWeight: "700",
    color: isHovered ? "#e72229" : "black",
    display: "-webkit-box",
    WebkitLineClamp: "2",
    lineClamp: "2",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    transition: "0.3s",
  };

  return (
    <div
      style={blockStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div style={blockImgStyle}>
        <Link href={`/services/${service?.slug}`} legacyBehavior>
          <a style={linkStyle}></a>
        </Link>
        <Image
          src={buildApiUrl(service?.image)}
          alt="service-img"
          width={1920}
          height={1080}
          loading="lazy"
          quality={100}
          style={imgStyle}
        />
      </div>

      <div style={contentStyle}>
        <Link href={`/services/${service?.slug}`} legacyBehavior>
          <a style={titleStyle}>
            {service?.title?.[locale].length > 50
              ? service?.title?.[locale].slice(0, 50) + "..."
              : service?.title?.[locale].slice(0, 50)}
          </a>
        </Link>
      </div>
    </div>
  );
};

const Services = ({ AllServicesData }) => {
  const { locale } = useRouter();
  const dir = locale === "ar" ? "rtl" : "ltr";

  return (
    <div className={styles.services}>
      <Container>
        {AllServicesData?.length > 0 && (
          <div className="custom-head">
            {/* <Image
              src={BlueHoleIcon}
              alt=""
              className={styles.BlueHoleIcon}
              width={100}
              height={100}
              priority={true}
            /> */}
            <p>
              <FormattedMessage id="services" />
            </p>
          </div>
        )}

        <Swiper
          dir={dir}
          key={dir}
          modules={[Navigation]}
          navigation
          spaceBetween={0}
          breakpoints={{
            320: { slidesPerView: 1, spaceBetween: 150 },
            576: { slidesPerView: 2, spaceBetween: 50 },
            768: { slidesPerView: 2, spaceBetween: 50 },
            992: { slidesPerView: 3, spaceBetween: 50 },
            1200: { slidesPerView: 3, spaceBetween: 50 },
          }}
        >
          {AllServicesData?.length > 0 &&
            AllServicesData?.map((service, index) => {
              return (
                <SwiperSlide key={index}>
                  <ServiceSlide service={service} dir={dir} locale={locale} />
                </SwiperSlide>
              );
            })}
        </Swiper>
      </Container>
    </div>
  );
};

export default Services;
